import './slide1.scss';

export const Slide1 = () => {
    return (
        <div className='container-slide slide1'>

            <div className='div-pai-slides'>

                <h1 className='bracket-title'>  Para sua empresa  </h1>
                <p className='slide-subtitle'>
                    Proteja seu negócio das oscilações cambiais
                </p>
                <p className='slide-text'>
                    Através do nossos serviços de hedge, fixamos os valores das
                    cotações das moedas para operações futuras, garantindo a
                    proteção dos contratos e previsibilidade de seu fluxo de caixa.
                </p>

                <a className='slide-button'style={{marginTop:"10px"}} href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>

            </div>

        </div>

    )
}
